import React from 'react';
import NavbarDesktop from './NavbarDesktop';
import NavbarMobile from "./NavbarMobile"

function About() {
	return(
		<div>
			<NavbarDesktop />
			<NavbarMobile />
			
			<div className="content">
				<h1 className="text-center">About</h1>

				<div className='home-desktop m-4'>
					<h2 className="text-center">Disclaimer</h2>
					<p className='font-normal'>
						All data used here is the sole property of the NWS (National Weather Service). 
						The use of this data in Surf Journal is not affiliated with the NWS or any of its counterparts. 
						The data has not been modified from its original source, but still cannot be considered official 
						government information. Any use of the NWS data via Surf Journal will be at the risk of the user.
					</p>
				</div>
			</div>
		</div>
	)
}

export default About;